import { render, staticRenderFns } from "./CarDetailInfoTable.vue?vue&type=template&id=032cf6cf&scoped=true&"
import script from "./CarDetailInfoTable.vue?vue&type=script&lang=js&"
export * from "./CarDetailInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./CarDetailInfoTable.vue?vue&type=style&index=0&id=032cf6cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032cf6cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
